import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CurrentMember,
  MemberListItem,
  MemberListQuery,
  MemberListResponse,
} from './types/member';

const request = createAppRequest();
const AUTH_PREFIX = process.env.UMI_APP_AUTH_BFF_URL || '';

const normalizeMemberList = (
  response: MemberListResponse | MemberListItem[] | undefined,
): MemberListItem[] => {
  if (Array.isArray(response)) {
    return response;
  }

  return (
    response?.list ||
    response?.items ||
    response?.data ||
    response?.members ||
    []
  );
};

export async function getCurrentMember(options?: ApiRequestOptions) {
  return request<CurrentMember>(`${AUTH_PREFIX}/bff/iam-ui/members/me`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function queryMembers(
  params?: MemberListQuery,
  options?: ApiRequestOptions,
) {
  const response = await request<MemberListResponse | MemberListItem[]>(
    `${AUTH_PREFIX}/bff/iam-ui/members`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );

  return normalizeMemberList(response);
}
